// BOORO: everything an agent writes for the person is read at a glance. The rules
// follow the parts of ASD-STE100 (Simplified Technical English) that carry over to
// any language; its English word list does not, so the rules are spelled out.

/** How an agent writes what the person reads: chat answers, tasks, results, comments. */
export const PLAIN_WRITING_GUIDANCE = [
  "Writing: everything you write for the user is read at a glance, so write plain text in the user's language.",
  "One idea per sentence, at most about 20 words. Use active voice and say who does what; write instructions as imperatives, one per sentence.",
  "Always call one thing by the same name. Be concrete: name numbers, files and places instead of vague words.",
  "Leave out filler, preamble and repeating what the user said. Use a short list when there are more than two points.",
].join(" ");
